import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ScheduleService } from '@app/core/services';
import { PortalUtils } from '@app/core/utils/portal.utils';
import { isString } from 'lodash-es';

@Component({
  selector: 'app-menu-float-bar',
  templateUrl: './menu-float-bar.component.html',
  styleUrls: ['./menu-float-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuFloatBarComponent {
  @Input() public data: any;
  public showMenu = false;

  constructor(
    public dialog: MatDialog,
    public scheduleService: ScheduleService,
  ) {}

  public onSchedule() {
    return this.scheduleService.schedulingOnline();
  }

  public onToogle(event: any) {
    event.stopPropagation();
    this.showMenu = !this.showMenu;
  }

  public onCloseMenu() {
    this.showMenu = false;
  }

  public legend(data: any): string {
    return PortalUtils.legend(data);
  }

  public isString(value: any): boolean {
    return isString(value);
  }
}
